var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1906_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.526 25.474L1.054 20C.402 19.334 0 18.391 0 17.473 0 17.047.24 16.38.421 16L5.473 5.473l1.053 20z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.263 6.526L19.79 1.054C19.313.573 18.317 0 17.475 0c-.724 0-1.435.146-1.894.421L5.477 5.473l19.786 1.053zM13.052 32h13.264v-5.684l-9.895-3.16-9.053 3.16L13.052 32z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.473 22.527c0 1.689.211 2.103 1.051 2.947l.842.843h18.95L17.054 15.79 5.473 5.473v17.054z",
    fill: "#29B6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.317 5.473H5.473l20.843 20.84H32V13.263l-6.737-6.738c-.947-.948-1.787-1.051-2.946-1.051z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.738 25.683c-.842-.844-1.052-1.677-1.052-3.156V5.684l-.209-.211v17.054c0 1.48 0 1.89 1.26 3.156z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.79 13.052v13.052h-5.683l.21.212H32V13.261l-.21-.209z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.263 6.526c-1.043-1.044-1.897-1.053-3.156-1.053H5.477l.21.209h16.42c.628 0 2.214-.106 3.157.843l-.001.001z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.79 13.052l-6.527-6.526-5.473-5.472C19.313.573 18.317 0 17.475 0c-.724 0-1.435.146-1.894.421L5.477 5.473.423 16C.243 16.383 0 17.049 0 17.473c0 .92.405 1.858 1.051 2.526l5.047 5.01c.134.162.278.318.428.465l.21.21.63.63 5.472 5.473.21.21h13.261v-5.683h5.684V13.26l-.202-.209z",
    fill: "url(#paint0_radial_1906_165)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1906_165",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.996 15.998) scale(15.9973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1906_165"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.434a3aebd9559ffb335f5d0eb058b80f.svg";
export { ForwardRef as ReactComponent };